<template>
    <div class="profile-details" v-if="user">
        <div>
            <avatar v-if="user.avatar" :avatar="user.avatar" class="avatar"></avatar>
            <img v-else="" src="../../../images/avatar.svg" class="avatar"/>

            <h4 class="name">{{ user.name }}</h4>
            <p class="school" v-if="user.school">{{ user.school.title }}</p>
            <p class="description">{{ user.description }}</p>
        </div>

        <ul class="profile-nav">
            <li><router-link :to="{ name: 'profile.bookmarks' }" class="with-icon"><svg-icon :symbol="bookmarkIcon" :original-dims="true"></svg-icon><span>Manas grāmatzīmes</span></router-link></li>
            <li><router-link :to="{ name: 'inbox.comments' }" class="with-icon"><svg-icon :symbol="commentIcon" :original-dims="true"></svg-icon><span>Komentāri</span><span v-if="inboxStats && inboxStats.newCommentsCount > 0" class="badge">{{inboxStats.newCommentsCount}}</span></router-link></li>
            <li><router-link :to="{ name: 'inbox.messages'}" class="with-icon"><svg-icon :symbol="messageIcon" :original-dims="true"></svg-icon><span>Ziņas</span><span v-if="inboxStats && inboxStats.newMessagesCount > 0" class="badge">{{inboxStats.newMessagesCount}}</span></router-link></li>
        </ul>

        <div>
            <h4>Kopējā statistika</h4>

            <ul class="profile-stats">
                <li class="with-icon"><svg-icon :symbol="likeIcon" :original-dims="true"></svg-icon>Patīk: {{ statistics.likes }}</li>
                <li class="with-icon"><svg-icon :symbol="viewIcon" :original-dims="true"></svg-icon>Skatījumi: {{ statistics.views }}</li>
                <li class="with-icon"><svg-icon :symbol="downloadIcon" :original-dims="true"></svg-icon>Lejuplādes: {{ statistics.downloads }}</li>
            </ul>
        </div>

        <router-link :to="{ name: 'profile.edit' }" class="button default">Labot</router-link>
    </div>
</template>

<script>
    import SvgIcon from '../SvgIcon'
    import Avatar from '../Avatar'
    import { mapGetters } from 'vuex'

    import bookmarkIcon from '../../../icons/icon-bookmark.svg-sprite'
    import commentIcon from '../../../icons/icon-comment.svg-sprite'
    import messageIcon from '../../../icons/icon-message.svg-sprite'
    import likeIcon from '../../../icons/icon-like.svg-sprite'
    import viewIcon from '../../../icons/icon-view.svg-sprite'
    import downloadIcon from '../../../icons/icon-download.svg-sprite'

    import users from "../../api/users";
    import user from '../../api/user';

    export default {
        data() {
            return {
                bookmarkIcon,
                commentIcon,
                messageIcon,
                likeIcon,
                viewIcon,
                downloadIcon,

                statistics: {
                    likes: 0,
                    views: 0,
                    downloads: 0
                },
            }
        },

        computed: {
            ...mapGetters(['user', 'inboxStats']),
        },

        created() {
            if (this.user) {
                this.getStatistics();
            }
            this.$store.dispatch('getInboxStats');
        },

        methods: {
            /**
             * Get User statistics
             */
            getStatistics() {
                users.statistics(this.user.id).then(response => {
                    this.statistics = response.data;
                })
            },

            /**
             * Reset component data
             */
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))
            }
        },

        watch: {
            /**
             * Reload user profile when user changes or signs out.
             *
             * @param val
             * @param oldVal
             */
            user: function (val, oldVal) {
                if (!val) {
                    this.reset();
                } else if (oldVal === null || val.id !== oldVal.id ) {
                    this.getStatistics();
                }
            },
        },

        components: {
            Avatar, SvgIcon
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .profile-details {
        font-size: 12px/16px + rem;

        .avatar {
            display: block;
            margin-bottom: 2em;
            width: 86px;
            height: 86px;
        }

        p {
            margin: 0;
        }

        h4 {
            font-weight: 700;
            margin-bottom: 0;
            font-size: px-em(14px, 12px);
        }

        .description {
            margin-top: 2em;
        }

        > *:not(:last-child) {
            margin-bottom: 2em;
        }
    }

    .profile-nav {
        @include reset-list();
        margin-bottom: 2em;

        > li {
            margin-bottom: 0.75em;
        }

        > li > a {
            color: inherit;
            font-weight: 700;
            font-size: px-em(13px, 12px);
            padding-left: 20px;//Compensate inline icon

            &:hover,
            &:active {
                text-decoration: underline;
            }
        }

        .badge {
            margin-left: 0.5em;
        }

        svg {
            fill: #404141;
        }
    }

    .profile-stats {
        @include reset-list();

        svg {
            fill: #999999;
        }

        > li {
            padding-left: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/profile/MyProfileInfo.vue